import _slicedToArray from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { curry, pipe, toPairs, map, set, get, reduceRight, merge } from 'lodash/fp';
export var mapper = curry(function (mapping, object) {
  return pipe([toPairs, map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];

    return set(to, get(from, object), {});
  }), reduceRight(merge, object)])(mapping);
});
export default mapper;